module.exports = __webpack_public_path__ + "img/ic_chevron_right_white_48px.2d552baa.svg";